export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';

    const digits = phoneNumber.replace(/\D/g, '');

    // Brasil com código do país (+55)
    const brazilWithCountry = /^(\d{2})(\d{2})(\d{5})(\d{4})$/;
    const brazilNoCountry = /^(\d{2})(\d{5})(\d{4})$/;

    // Internacional genérico: +CC XXXXX XXXX
    const international = /^(\d{1,3})(\d{1,4})(\d{3,4})(\d{4})$/;

    let match;

    if ((match = digits.match(brazilWithCountry))) {
        const [, country, ddd, first, last] = match;
        return `+${country} (${ddd}) ${first}-${last}`;
    } else if ((match = digits.match(brazilNoCountry))) {
        const [, ddd, first, last] = match;
        return `(${ddd}) ${first}-${last}`;
    } else if ((match = digits.match(international))) {
        const [, country, part1, part2, part3] = match;
        return `+${country} ${part1} ${part2}-${part3}`;
    }

    // Se não casar, retorna número limpo
    return digits;
};

export const formatPhoneNumberOfPhoneComponent = (phone) => {
    if (!phone) return '';

    const regex = /^\+55(\d{2})(\d{5})(\d{4})$/;

    const match = phone.match(regex);
    if (match) {
        const [, ddd, firstPart, secondPart] = match;
        return `+55 (${ddd}) ${firstPart}.${secondPart}`;
    }

    return phone; // Retorna como está se não bater com o padrão
};

// Forma um número em duas casas decimais
export const formatNumberWithTwoDecimalPlaces = (value) => {
    return value.toFixed(2);
}

export const formatNumberWithTwoDecimals = (number) => {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
}

// Formata um endereço para uma string contendo o endereço completo.
export const formatFullAddress = (address) => {
    let addr = address.street;

    if (address.number != null && address.number.trim() !== '') {
        addr += ", " + address.number;
    }
    if (address.complement != null && address.complement.trim() !== '') {
        addr += ", " + address.complement;
    }
    if (address.neighborhood != null && address.neighborhood.trim() !== '') {
        addr += ", " + address.neighborhood;
    }
    if (address.city != null && address.city.trim() !== '') {
        addr += ", " + address.city;
    }
    if (address.state != null && address.state.trim() !== '') {
        addr += ", " + address.state;
    }

    return addr;
}

// Formata um endereço para uma string contendo o endereço completo.
export const formatSimplifiedFullAddress = (address) => {
    let addr = address.street;

    if (address.number != null && address.number.trim() !== '') {
        addr += ", " + address.number;
    }
    if (address.neighborhood != null && address.neighborhood.trim() !== '') {
        addr += ", " + address.neighborhood;
    }

    return addr;
}

export const formatZipCode = (zipCode) => {
    // Remove todos os caracteres não numéricos
    zipCode = zipCode.replace(/\D/g, '');

    // Verifica se o CEP tem o tamanho correto (8 dígitos)
    if (zipCode.length !== 8) {
        return zipCode; // Retorna o CEP original se não tiver o tamanho correto
    }

    // Insere o hífen na posição correta
    return zipCode.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export const formatCNPJ = (cnpj) => {
    if (!cnpj) return '';

    const value = String(cnpj);
    if (value.trim() === '') return '';

    // Remove all non-numeric characters
    const digits = value.replace(/\D/g, '');

    // Check if the CNPJ has the correct length (14 digits)
    if (digits.length !== 14) {
        return digits; // Return the original CNPJ if the length is incorrect
    }

    // Insert dots and hyphen in the correct positions
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export const formatCPF = (cpf) => {
    if (!cpf) return '';

    const value = String(cpf);
    if (value.trim() === '') return '';

    // Remove all non-numeric characters
    const digits = value.replace(/\D/g, '');

    // Check if the CPF has the correct length (11 digits)
    if (digits.length !== 11) {
        return digits; // Return the original CPF if the length is incorrect
    }

    // Insert dots and hyphen in the correct positions
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export const removePhoneNumberPunctuation = (phoneNumber) => {
    // Regular expression to remove all non-digit characters
    return phoneNumber.replace(/\D/g, '');
}
// O WhatsApp só abre a conversa com o número em dígitos e com DDI. Os telefones são
// gravados sem o 55 e, na metade dos cadastros, com a máscara do formulário: mandar o
// valor cru para o wa.me não abre conversa nenhuma. DDD + assinante (10 ou 11 dígitos)
// ganha o 55; número que já veio com DDI ou de outro país passa como está.
export const buildWhatsappPhone = (phone) => {
    const digitsOnly = String(phone || '').replace(/\D/g, '');

    return digitsOnly.length === 10 || digitsOnly.length === 11
        ? `55${digitsOnly}`
        : digitsOnly;
};

// Link de conversa no WhatsApp. A mensagem é opcional: sem ela o link só abre o contato.
export const buildWhatsappUrl = (phone, message) => {
    const url = `https://api.whatsapp.com/send?phone=${buildWhatsappPhone(phone)}`;

    return message ? `${url}&text=${encodeURIComponent(message)}` : url;
};

// O WhatsApp não permite que a aplicação envie a mensagem sem a confirmação do usuário.
// Por isso, o fluxo de aniversariantes abre a conversa com um texto personalizado pronto
// para revisão e envio, evitando que o operador precise redigitar a mensagem para cada cliente.
export const buildBirthdayWhatsappMessage = (fullName, audience = 'cliente') => {
    const firstName = String(fullName || '').trim().split(/\s+/)[0] || 'você';
    const greeting = audience === 'employee' ? 'A equipe deseja' : 'Nós desejamos';

    return `Olá, ${firstName}! 🎉\n\n${greeting} um feliz aniversário, com muita saúde, felicidade e sucesso! Que seu dia seja especial. 😊`;
};

// Junta nomes em lista corrida do português: "Corte", "Corte e Barba", "Corte, Barba e
// Sobrancelha". Usado em avisos ao cliente que citam os serviços afetados.
export const formatNameList = (names) => {
    const list = (names || []).filter(Boolean);
    return new Intl.ListFormat('pt-BR', { style: 'long', type: 'conjunction' }).format(list);
};

/** Tamanho de arquivo para exibição: "820 KB", "4,2 MB". */
export const formatFileSize = (bytes) => {
    if (!Number.isFinite(bytes)) {
        return '';
    }
    if (bytes < 1024 * 1024) {
        return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    }
    return `${(bytes / (1024 * 1024)).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB`;
};
